<htm-swiper [config]="config" [resolveElements]="false" #usefulSwiper>
  <div class="swiper-wrapper" aria-roledescription="carousel" aria-live="polite" id="carousel-content">
    @for (item of data; track item; let i = $index; let l = $count) {
      @if (item.link.routed) {
        <a class="swiper-slide slides__instance"
          [routerLink]="item.link.path"
          [attr.data-test-id]="'carousel-link-' + (item?.link?.path | slugify)"
          >
          <div class="slides__elem">
            <div class="slides__elem__image" [style.height]="imageHeight">
              <img [src]="item.image.url" alt="" />
            </div><!--/slides__elem__image-->
            <div class="slides__elem__body" [style.height]="bodyHeight">
              <h3 class="slides__elem__title" [attr.aria-label]="item.title" [id]="'described-by-' + (item.title | slugify)" [style.height.px]="titleHeight">{{ item.title }}</h3>
              <p class="slides__elem__text" [style.height.px]="textHeight" [innerHTML]="item.content | shorten: 130 : '' : true : true"></p>
            </div><!--/slides__elem__body-->
          </div><!--/slides__elem-->
        </a>
        }<!--/slides__instance-->
        @if (!item.link.routed) {
          <a class="swiper-slide slides__instance"
            [href]="item.link.path"
            [attr.data-test-id]="'carousel-link-' + (item?.link?.path | slugify)"
            >
            <div class="slides__elem">
              <div class="slides__elem__image" [style.height]="imageHeight">
                <img [src]="item.image.url" alt="" />
              </div><!--/slides__elem__image-->
              <div class="slides__elem__body" [style.height.px]="bodyHeight">
                <h3 class="slides__elem__title" [attr.aria-label]="item.title" [id]="'described-by-' + (item.title | slugify)" [style.height.px]="titleHeight">{{ item.title }}</h3>
                <p class="slides__elem__text" [style.height.px]="textHeight" [innerHTML]="item.content | shorten: 130 : '' : true : true"></p>
              </div><!--/slides__elem__body-->
            </div><!--/slides__elem-->
          </a>
          }<!--/slides__instance-->
        }
      </div>
      <div class="swiper-pagination" aria-hidden="true" tabindex="-1"></div>
    </htm-swiper>
    <div class="slides__arrow slides__arrow--left" aria-hidden="true" tabindex="-1" data-test-id="carousel-main-backwards-button">
      <icon glyph="chevron-left"></icon>
    </div>
    <div class="slides__arrow slides__arrow--right" aria-hidden="true" tabindex="-1" data-test-id="carousel-main-forwards-button">
      <icon glyph="chevron-right"></icon>
    </div>
